// THIS FILE IS AUTO-GENERATED. DO NOT MODIFY IT.
// Please edit ./night.theme.ts instead, then run `npm run theme:build`
import { css } from '@linaria/core'

export default css`
  --gray00: #100f0e;
  --gray00a: rgba(255, 0, 0, 0.012);
  --gray02: #21201e;
  --gray02a: rgba(255, 217, 179, 0.078);
  --gray03: #2c2b29;
  --gray03a: rgba(255, 230, 206, 0.122);
  --gray05: #363431;
  --gray05a: rgba(255, 230, 205, 0.161);
  --gray10: #3f3e3a;
  --gray10a: rgba(255, 240, 214, 0.196);
  --gray20: #4f4e4a;
  --gray20a: rgba(255, 243, 224, 0.259);
  --gray30: #615f5a;
  --gray30a: rgba(255, 243, 225, 0.329);
  --gray40: #73706c;
  --gray40a: rgba(255, 243, 230, 0.4);
  --gray50: #86837e;
  --gray50a: rgba(255, 244, 232, 0.475);
  --gray60: #9a9692;
  --gray60a: rgba(255, 244, 235, 0.553);
  --gray70: #b0aca8;
  --gray70a: rgba(255, 246, 238, 0.639);
  --gray80: #c9c4c0;
  --gray80a: rgba(255, 246, 239, 0.737);
  --gray90: #e3dfdb;
  --gray90a: rgba(255, 248, 242, 0.839);
  --gray100: #fdfcfc;
  --gray100a: rgba(255, 252, 251, 0.941);
  --blue02: #10222b;
  --blue02a: rgba(28, 179, 255, 0.106);
  --blue03: #132e3c;
  --blue03a: rgba(35, 180, 255, 0.173);
  --blue05: #143849;
  --blue05a: rgba(31, 183, 255, 0.224);
  --blue10: #154257;
  --blue10a: rgba(29, 183, 255, 0.278);
  --blue20: #1c546c;
  --blue20a: rgba(42, 191, 255, 0.361);
  --blue30: #2c6580;
  --blue30a: rgba(71, 196, 255, 0.439);
  --blue40: #3f7791;
  --blue40a: rgba(99, 206, 255, 0.506);
  --blue50: #548aa3;
  --blue50a: rgba(123, 213, 255, 0.576);
  --blue60: #679eb5;
  --blue60a: rgba(139, 221, 255, 0.647);
  --blue70: #7cb5ca;
  --blue70a: rgba(152, 228, 255, 0.729);
  --blue80: #94cedf;
  --blue80a: rgba(166, 235, 255, 0.812);
  --blue90: #b4e9f5;
  --blue90a: rgba(186, 243, 255, 0.898);
  --green02: #0f2314;
  --green02a: rgba(26, 255, 51, 0.078);
  --green03: #19301d;
  --green03a: rgba(93, 255, 100, 0.129);
  --green05: #233a23;
  --green05a: rgba(130, 255, 113, 0.169);
  --green10: #2c4329;
  --green10a: rgba(152, 255, 123, 0.204);
  --green20: #3d5433;
  --green20a: rgba(177, 255, 129, 0.271);
  --green30: #4f653d;
  --green30a: rgba(196, 255, 133, 0.337);
  --green40: #627747;
  --green40a: rgba(208, 255, 135, 0.408);
  --green50: #778a51;
  --green50a: rgba(220, 255, 135, 0.482);
  --green60: #8d9e5b;
  --green60a: rgba(228, 255, 134, 0.561);
  --green70: #a6b466;
  --green70a: rgba(236, 255, 133, 0.647);
  --green80: #c1cc74;
  --green80a: rgba(243, 255, 135, 0.741);
  --green90: #dee69f;
  --green90a: rgba(248, 255, 170, 0.843);
  --yellow02: #311a0d;
  --yellow02a: rgba(255, 78, 0, 0.141);
  --yellow03: #44220f;
  --yellow03a: rgba(255, 88, 0, 0.216);
  --yellow05: #542810;
  --yellow05a: rgba(255, 90, 0, 0.278);
  --yellow10: #652e0f;
  --yellow10a: rgba(255, 90, 0, 0.345);
  --yellow20: #82380a;
  --yellow20a: rgba(255, 89, 0, 0.459);
  --yellow30: #a04200;
  --yellow30a: rgba(255, 88, 0, 0.576);
  --yellow40: #b85300;
  --yellow40a: rgba(255, 101, 0, 0.671);
  --yellow50: #be7021;
  --yellow50a: rgba(255, 140, 24, 0.694);
  --yellow60: #c78b37;
  --yellow60a: rgba(255, 170, 53, 0.729);
  --yellow70: #d5a647;
  --yellow70a: rgba(255, 193, 70, 0.784);
  --yellow80: #e5c15c;
  --yellow80a: rgba(255, 210, 90, 0.847);
  --yellow90: #f9df83;
  --yellow90a: rgba(255, 225, 124, 0.925);
  --red02: #2f191f;
  --red02a: rgba(255, 75, 113, 0.133);
  --red03: #40212a;
  --red03a: rgba(255, 90, 130, 0.2);
  --red05: #512834;
  --red05a: rgba(255, 94, 135, 0.267);
  --red10: #612d3d;
  --red10a: rgba(255, 91, 137, 0.329);
  --red20: #7f354d;
  --red20a: rgba(255, 85, 136, 0.447);
  --red30: #a13a5e;
  --red30a: rgba(255, 74, 134, 0.58);
  --red40: #c53e68;
  --red40a: rgba(255, 65, 122, 0.722);
  --red50: #cf5f78;
  --red50a: rgba(255, 105, 137, 0.761);
  --red60: #da7b8a;
  --red60a: rgba(255, 134, 152, 0.804);
  --red70: #ec959f;
  --red70a: rgba(255, 153, 164, 0.875);
  --red80: #fbb2b9;
  --red80a: rgba(255, 175, 181, 0.933);
  --red90: #fdd7da;
  --red90a: rgba(255, 213, 215, 0.941);
  --purple02: #221e27;
  --purple02a: rgba(233, 166, 255, 0.09);
  --purple03: #2e2834;
  --purple03a: rgba(234, 177, 255, 0.141);
  --purple05: #3a3142;
  --purple05a: rgba(229, 173, 255, 0.196);
  --purple10: #44394f;
  --purple10a: rgba(223, 170, 255, 0.247);
  --purple20: #574866;
  --purple20a: rgba(219, 169, 255, 0.337);
  --purple30: #6b567f;
  --purple30a: rgba(216, 163, 255, 0.435);
  --purple40: #80659b;
  --purple40a: rgba(211, 158, 255, 0.545);
  --purple50: #9775b8;
  --purple50a: rgba(209, 155, 255, 0.659);
  --purple60: #b084db;
  --purple60a: rgba(205, 147, 255, 0.796);
  --purple70: #cb97fc;
  --purple70a: rgba(205, 147, 255, 0.925);
  --purple80: #d7b9f6;
  --purple80a: rgba(224, 188, 255, 0.902);
  --purple90: #e7dbf5;
  --purple90a: rgba(243, 227, 255, 0.898);
  --danger02: #331815;
  --danger02a: rgba(255, 60, 34, 0.149);
  --danger03: #46201a;
  --danger03a: rgba(255, 76, 45, 0.224);
  --danger05: #57251f;
  --danger05a: rgba(255, 76, 52, 0.29);
  --danger10: #692a23;
  --danger10a: rgba(255, 75, 53, 0.361);
  --danger20: #873229;
  --danger20a: rgba(255, 73, 52, 0.478);
  --danger30: #a73a30;
  --danger30a: rgba(255, 71, 53, 0.604);
  --danger40: #c2473d;
  --danger40a: rgba(255, 79, 63, 0.71);
  --danger50: #d65d52;
  --danger50a: rgba(255, 99, 84, 0.788);
  --danger60: #e3786e;
  --danger60a: rgba(255, 125, 112, 0.839);
  --danger70: #f0958a;
  --danger70a: rgba(255, 151, 137, 0.89);
  --danger80: #f9b4a8;
  --danger80a: rgba(255, 178, 164, 0.925);
  --danger90: #ffd7cc;
  --danger90a: rgba(255, 211, 198, 0.949);
  --elev-veil-color: white;
  --gradient-color-base: 4%;

  color-scheme: dark;
  color: var(--gray100);
  &:not([transparent]) {
    background: var(--gray00);
  }
`
